import { toast, toastClose, toastDestroy } from '@landlord-tech/ui-kit-opp';

export default toast;
export { toastClose, toastDestroy };
